import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import {
	GetSeasonProductQueryType,
	SeasonProductBatchUpdateType,
	SeasonProductPhaseUpdateType,
} from '@schemas'

export const getSeasonProduct = async ({
	params = {},
	body = {},
	query = {
		seasonId: '',
	} as GetSeasonProductQueryType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season-product'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const batchUpdateSeasonProduct = async ({
	params = {},
	query = {},
	body = { productList: [] as SeasonProductBatchUpdateType[] },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season-product/batch-update'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/**
 * shop 상품 조회.
 *
 * seasonId 를 생략하면 서버가 현재 판매중(OPEN_YN=1)인 시즌을 쓴다.
 * 빈 문자열을 실어 보내면 안 된다 — 서버 Joi 가 400 으로 거부한다.
 */
export const getShopSeasonProduct = async ({
	params = {},
	body = {},
	query = {} as Partial<GetSeasonProductQueryType>,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/season-product/shop'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getShopSeasonProductDetail = async ({
	params = { sessionProductId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/season-product/shop/${params.sessionProductId}`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 시즌 상품 하나의 판매·이행 단계 전부. 상세 화면 전용(관리자). */
export const getSeasonProductPhase = async ({
	params = { seasonProductId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/season-product/${params.seasonProductId}/phase`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 단계를 통째로 맡긴다. 서버가 PHASE 이름으로 찾아 넣거나 덮는다. */
export const batchUpdateSeasonProductPhase = async ({
	params = { seasonProductId: '' },
	query = {},
	body = { phaseList: [] as SeasonProductPhaseUpdateType[] },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/season-product/${params.seasonProductId}/phase`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const seasonProductApi = {
	getSeasonProduct: getSeasonProduct,
	batchUpdateSeasonProduct: batchUpdateSeasonProduct,
	getShopSeasonProduct: getShopSeasonProduct,
	getShopSeasonProductDetail: getShopSeasonProductDetail,
	getSeasonProductPhase: getSeasonProductPhase,
	batchUpdateSeasonProductPhase: batchUpdateSeasonProductPhase,
}

export default seasonProductApi
